import { toast } from '@conexasaude/conexa-hero'
import { MutationCache, QueryCache, QueryClient } from 'react-query'
import { ConexaResponseError } from '@/types'

const handleOnError = (error: ConexaResponseError) => {
  return toast({
    message:
      error?.response?.data?.msg ||
      'Aconteceu um problema inesperado, sentimos muito.',
    variant: 'error',
  })
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: ConexaResponseError, query) => {
      if (query?.meta?.skipGlobalError) return
      handleOnError(error)
    },
  }),
  mutationCache: new MutationCache({
    onError(error: ConexaResponseError, _, __, mutation) {
      if (mutation?.meta?.skipGlobalError) return
      handleOnError(error)
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

export default queryClient
